import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class PingService {
  private static baseUrl: string = '/api';

  public static tags = {
    ping: 'ping',
  };

  static ping = (): Promise<string> =>
    trackPromise(
      new Promise<string>((resolve, reject) => {
        http(`${this.baseUrl}/ping?hitDb=false`)
          .get<string>()
          .then((json) => resolve(json))
          .catch(reject);
      }),
      this.tags.ping,
    );
}
